import React from "react";
import { Avatar, Grid, ListItem, Typography } from "@mui/material";

const PlantListItem = ({ plant }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {/* <Avatar src={plant.image} alt={plant.name} /> */}
        <img
          src={plant.image}
          alt={plant.name}
          style={{
            width: "100%",
            height: "15rem",
            objectFit: "cover",
            borderRadius: "2rem",
            boxShadow: "rgba(0, 0, 0, 0.5) 0px 0px 42px 0px",
          }}
        />
      </Grid>
      <Grid item xs={12} sm container>
        <Grid item xs container direction="column" spacing={2}>
          <Grid item xs>
            <Typography variant="h6">{plant.name}</Typography>
            <Typography variant="body1" color="secondary">
              {plant.description}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

// function PlantListItem({ plant }) {
//   let name = plant.name;
//   let plantImage = plant.image;

//   return (
//     <ListItem
//       key={name}
//       style={{
//         cursor: "pointer",
//         backgroundColor: isSelected ? "#e0e0e0" : "white",
//       }}
//       secondaryAction={
//         <IconButton
//           onClick={() => onAddPlant(plant)}
//           edge="end"
//           aria-label="comments"
//         >
//           <Add />
//         </IconButton>
//       }
//     >
//       <ListItemAvatar onClick={() => onPlantClick(plant)}>
//         <Avatar src={plantImage} alt={name} />
//       </ListItemAvatar>
//       <ListItemText
//         onClick={() => onPlantClick(plant)}
//         primary={name}
//         secondary={`Quantity: ${quantity}`}
//       />
//     </ListItem>
//   );
// }

export default PlantListItem;
